import React from 'react';

const TeamNavbar = ({title}) => {
    return (
        <nav className="layout-navbar container-xxl navbar-detached navbar navbar-expand-xl align-items-center bg-navbar-theme" id="layout-navbar">

            <div className="layout-menu-toggle navbar-nav align-items-xl-center me-4 me-xl-0 d-xl-none">
                <a className="nav-item nav-link px-0 me-xl-6" href="#!">
                    <i className="icon-base bx bx-menu icon-md"></i>
                </a>
            </div>

            <div className="navbar-nav-right d-flex align-items-center justify-content-end" id="navbar-collapse">

                <div className="navbar-nav align-items-center">
                    <div className="nav-item navbar-search-wrapper mb-0">
                        <h5 className="modal-title" id="modalFullTitle">{title}</h5>
                    </div>
                </div>

                {/* Language Switcher */}
                <ul className="navbar-nav flex-row align-items-center ms-md-auto">
                    {/*<li className="nav-item dropdown-language dropdown me-2 me-xl-0">*/}
                    {/*    <a className="nav-link dropdown-toggle hide-arrow" href="#!" data-bs-toggle="dropdown">*/}
                    {/*        <i className="icon-base bx bx-globe icon-md"></i>*/}
                    {/*    </a>*/}
                    {/*    <ul className="dropdown-menu dropdown-menu-end">*/}
                    {/*        {["en", "fr", "ar", "de"].map(lang => (*/}
                    {/*            <li key={lang}>*/}
                    {/*                <a className="dropdown-item" href="#!" data-language={lang}>*/}
                    {/*                    <span>{lang === "en" ? "English" : lang === "fr" ? "French" : lang === "ar" ? "Arabic" : "German"}</span>*/}
                    {/*                </a>*/}
                    {/*            </li>*/}
                    {/*        ))}*/}
                    {/*    </ul>*/}
                    {/*</li>*/}

                    {/*/!* Theme Switcher *!/*/}
                    {/*<li className="nav-item dropdown me-2 me-xl-0">*/}
                    {/*    <a className="nav-link dropdown-toggle hide-arrow" href="#!" data-bs-toggle="dropdown">*/}
                    {/*        <i className="bx bx-sun icon-md"></i>*/}
                    {/*    </a>*/}
                    {/*    <ul className="dropdown-menu dropdown-menu-end">*/}
                    {/*        <li><button className="dropdown-item">Light</button></li>*/}
                    {/*        <li><button className="dropdown-item">Dark</button></li>*/}
                    {/*        <li><button className="dropdown-item">System</button></li>*/}
                    {/*    </ul>*/}
                    {/*</li>*/}

                    {/*/!* Shortcuts (just a placeholder example) *!/*/}
                    {/*<li className="nav-item dropdown-shortcuts navbar-dropdown dropdown me-2 me-xl-0">*/}
                    {/*    <a className="nav-link dropdown-toggle hide-arrow" href="#!" data-bs-toggle="dropdown">*/}
                    {/*        <i className="icon-base bx bx-grid-alt icon-md"></i>*/}
                    {/*    </a>*/}
                    {/*    <div className="dropdown-menu dropdown-menu-end p-0">*/}
                    {/*        <div className="dropdown-menu-header border-bottom">*/}
                    {/*            <div className="dropdown-header d-flex align-items-center py-3">*/}
                    {/*                <h6 className="mb-0 me-auto">Shortcuts</h6>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*        <div className="dropdown-shortcuts-list">*/}
                    {/*            <div className="row g-0">*/}
                    {/*                <div className="col text-center p-3">*/}
                    {/*                    <i className="bx bx-calendar icon-md"></i>*/}
                    {/*                    <div>Calendar</div>*/}
                    {/*                </div>*/}
                    {/*                <div className="col text-center p-3">*/}
                    {/*                    <i className="bx bx-user icon-md"></i>*/}
                    {/*                    <div>User App</div>*/}
                    {/*                </div>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*</li>*/}
                </ul>
            </div>
        </nav>
    );
};

export default TeamNavbar;
